var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopGuidedDownload"},[_c('div',{staticClass:"botBtn",on:{"click":function($event){return _vm.DownApp()}}},[_vm._v(" 前往App ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }